import React from 'react';

import classes from './Card.module.css';

type CardProps = {
  children: React.ReactNode;
  extraStyles?: React.CSSProperties;
  withMargin?: string;
};

const Card = ({ children, extraStyles, withMargin }: CardProps) => {
  let marginStyle = '';
  if (withMargin) {
    if (withMargin === 'top') {
      marginStyle = classes.withMarginTop;
    }
    if (withMargin === 'bottom') {
      marginStyle = classes.withMarginBottom;
    }
  }

  const cardStyle = `${classes.card} ${marginStyle}`;

  return (
    <div style={extraStyles} className={cardStyle}>
      {children}
    </div>
  );
};

export default Card;
